import { crmContactApi } from 'app/services/api';

// CRM value objects may serialize either as a bare guid string or as a wrapper
// object ({ value }). Normalize both shapes to a plain id string.
const normalizeId = value => value?.value ?? value ?? null;

// The 1:1 borrower<->contact constraint is intentionally deferred (see STP-26),
// so /api/contacts/by-borrower can return multiple links. Pick the most recent
// by CreatedDate — the same tie-break documented for the STP-32 bulk endpoint.
export const selectMostRecentLink = links => {
  if (!Array.isArray(links) || links.length === 0) {
    return null;
  }

  return [...links].sort(
    (a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime(),
  )[0];
};

// Interim per-borrower resolve (STP-32 replaces this with a single bulk call):
//   1. GET /api/contacts/by-borrower/{borrowerId} -> link(s) -> most recent -> contactId
//   2. GET /api/contacts/{contactId}             -> display fields for the chip
// Returns null when there is no link OR the lookup fails, so a single failing
// borrower never blanks the whole column.
export const resolveBorrowerContactSummary = async borrowerId => {
  try {
    const { data: links } = await crmContactApi.getContactByBorrowerId({ borrowerId });
    const link = selectMostRecentLink(links);
    const contactId = normalizeId(link?.contactId);

    if (!contactId) {
      return null;
    }

    const { data: contact } = await crmContactApi.getContactById(contactId);

    return {
      contactId,
      firstName: contact?.firstName ?? '',
      lastName: contact?.lastName ?? '',
      primaryEmail: contact?.primaryEmail ?? null,
      lifecycleStage: contact?.lifecycleStage ?? null,
    };
  } catch {
    return null;
  }
};
